var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form"},[_c('v-autocomplete',{attrs:{"id":"temas-select","items":_vm.values,"label":_vm.title,"placeholder":"Selecione...","outlined":"","disabled":_vm.disabled,"clearable":_vm.clearable,"multiple":_vm.multiple,"item-value":"municipio.municipioId","item-text":"municipio.nome","rules":_vm.rules},on:{"change":(e) => {
        _vm.$emit('onChange', _vm.value);
        _vm.$emit(
          'nameChange',
          _vm.allValues
            .filter((val) => _vm.value.municipioId.includes(val.municipioId))
            .map((item) => item.nome)
        );
      }},scopedSlots:_vm._u([{key:"selection",fn:function({ item, index }){return [(index < _vm.maxDisplay)?_c('v-chip',_vm._b({attrs:{"small":""}},'v-chip',item,false),[_c('span',[_vm._v(_vm._s(item.municipio.nome))])]):_vm._e(),(index === _vm.maxDisplay)?_c('span',{staticClass:"grey--text caption"},[_vm._v("(+"+_vm._s(_vm.value.municipioId.length - _vm.maxDisplay)+"\n        "+_vm._s(_vm.isParceiro
            ? "Parceiros"
            : _vm.isSala
            ? "Salas"
            : _vm.isGov
            ? "Projetos"
            : "Municípios")+")")]):_vm._e()]}}]),model:{value:(_vm.value.municipioId),callback:function ($$v) {_vm.$set(_vm.value, "municipioId", $$v)},expression:"value.municipioId"}},[_c('template',{slot:"no-data"},[_vm._v("\n      Nenhum\n      "+_vm._s(_vm.isParceiro
          ? "Parceiro"
          : _vm.isSala
          ? "Sala"
          : _vm.isGov
          ? "Projeto"
          : "Município")+"\n      retornado\n    ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }